<template>
	<el-dialog class="buy-dialog" :close-on-click-modal="false" title="网站配置" width="600px" @close="close" :visible.sync="dialogVisible">
		<div class="buy-dialog-main">
			<h2>
				<i class="i1"></i>
				<em class="em1"></em>小主您购买的网站个数已用完
				<i class="i2"></i>
				<em class="em2"></em>
			</h2>
			<h3>第3个网站起 购买享有以下优惠</h3>
			<!-- <h4><b>活动：</b>购买<span>1个3980元/年</span>；2≤购买数量≤19个,<span>平均1980元/年/个</span>；购买数量≥20个，<span>平均1580元/年/个</span></h4> -->
			<div class="repeat-box">
				<dl v-for="(item, i) in packageList" :key="i" v-show="item.suitLevel === '4'">
					<dt>
						<b>
							<span>￥</span>
							{{item.suitPrice}}
						</b>/年/个
					</dt>
					<dd class="tj" v-if="item.suitLevel === '3'">
						<b></b>
					</dd>
					<dd>
						<p>{{ item.suitLevel === '2'? '20个及以上': item.suitLevel === '3'? '2-19个': '1个' }}</p>
						<button @click="bindToBuy(item)">立即订购</button>
					</dd>
				</dl>
			</div>
		</div>
	</el-dialog>
</template>

<script>
import {
	mapState,
	mapActions,
	mapMutations,
	mapGetters
} from 'vuex'

export default {
	name: 'DialogWebConfig',
	components: {

	},
	data () {
		return {
			packageList: []
		}
	},
	computed: {
		...mapState('template', ['projInfo', 'showBuySite']),
		...mapGetters('user', ['userInfo']),
		dialogVisible: {
			get () {
				return this.showBuySite
			},
			set () {
				this.close()
			}
		}
	},
	created () {
		this.init()
	},
	methods: {
		...mapActions('templateConfig', ['getCommonInfo']),
		...mapMutations('template', ['setState']),
		...mapActions('order', ['getPackageList']),
		close () {
			this.setState({
				showBuySite: false
			})
		},
		init () {
			this.getPackageList().then(res => {
				this.packageList = res.data.data.filter(item => {
					return item.suitLevel !== '1'
				}).reverse()
			})
		},
		bindToBuy (item) {
			this.$router.push({
				name: 'packageEdit',
				params: {
					suitLevel: item.suitLevel
				}
			})
		}
	}
}

</script>

<style scoped lang="scss">
.buy-dialog-main {
	text-align: center;
	h2 {
		color: #000;
		font-size: 26px;
		height: 60px;
		line-height: 60px;
		font-weight: normal;
		padding-bottom: 20px;

		i {
			display: inline-block;
			width: 16px;
			height: 16px;
			background: #2d99f8;
			border-radius: 50%;
			position: relative;
		}

		em {
			display: inline-block;
			width: 16px;
			height: 16px;
			background: #ef7808;
			border-radius: 50%;
			position: relative;
		}

		.i1 {
			left: 5px;
			top: -3px;
			z-index: 1;
		}

		.i2 {
			right: -16px;
			top: -3px;
			z-index: 1;
		}

		.em1 {
			left: -20px;
			top: 3px;
		}

		.em2 {
			right: -10px;
			top: 3px;
		}
	}

	h3 {
		color: #58aaf9;
		font-size: 20px;
		font-weight: normal;
		height: 30px;
		line-height: 30px;
		margin-bottom: 20px;
	}

	h4 {
		font-size: 16px;
		color: #999;
		font-weight: normal;
		margin-bottom: 20px;

		b {
			color: #2d99f8;
		}

		span {
			color: #333;
		}
	}

	.repeat-box {
		display: flex;
		justify-content: center;
		dl {
			width: 250px;
			// width: 30%;
			border: 1px solid #ddd;
			border-top: 3px solid #ef7808;
			padding-bottom: 30px;
			position: relative;
			margin: 22px 0;

			dt {
				margin-top: 50px;
				height: 60px;
				line-height: 60px;
				font-size: 16px;

				b {
					color: #d0021a;
					font-size: 32px;
				}

				span {
					font-size: 20px;
				}
			}

			dd {
				margin-top: 20px;

				p {
					font-size: 20px;
				}

				button {
					display: inline-block;
					width: 160px;
					height: 45px;
					line-height: 45px;
					background: #ef7808;
					color: #fff;
					font-size: 20px;
					border: 0;
					margin-top: 40px;
				}
			}

			.tj {
				width: 65px;
				height: 65px;
				position: absolute;
				right: 0;
				top: 0;
				margin: 0;
				text-align: right;

				span {
					position: absolute;
				}

				b {
					width: 0;
					height: 0;
					border-top: 60px solid #ef7808;
					border-left: 60px solid transparent;
					display: inline-block;
					position: relative;
				}

				b:after {
					content: '推荐';
					position: absolute;
					right: 5px;
					top: -55px;
					display: block;
					width: 60px;
					color: #fff;
				}
			}
		}

		dl:nth-child(3) {
			margin-right: 0;
		}
	}
}
</style>
